var render = function render(){var _vm=this,_c=_vm._self._c;return _c('request-detail',{attrs:{"formData":_vm.basicInfoData,"formModel_R":_vm.formModel_R,"formModel_S":_vm.formModel_S,"model":_vm.model},on:{"clickSubmit":_vm.clickSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }